/* eslint-disable import/no-default-export */
import { EducationStatus } from '../../firebase/firestore/documents/seeker';

export default {
  send: 'Envoyer',
  email: 'Courriel',
  language: 'Langue',
  search: {
    label: 'Rechercher',
    candidateSearchLabel: 'Rechercher par nom de candidat',
    locationSearchLabel: 'Rechercher par nom de site',
    businessSearchLabel: `Rechercher par nom d'emplacement`,
    candidate: 'Candidat',
    business: 'Emplacement',
  },
  sorting: {
    label: 'Tri :', // ← hair space U+200A
    chronological: 'Date',
    alphabetical: 'A-Z',
  },
  grouping: {
    label: 'Regroupement :', // ← hair space U+200A
    none: 'Aucun',
    position: 'Poste',
    businessLocation: 'Site',
  },
  tabs: {
    profile: 'Profil',
    audioRecording: 'Enregistrement audio',
    messaging: 'Messagerie',
    questions: 'Questions',
    notes: 'Notes',
    history: 'Historique',
    PASS: 'Réussie',
    FAIL: 'Échouée',
    NEEDS_REVIEW: "Besoin d'entrevue",
  },
  account: {
    switchLang: 'English',
    logout: 'Se déconnecter',
    switchColorMode: {
      dark: 'Passer en mode claire',
      light: 'Passer en mode sombre',
    },
    administration: 'Administration',
    recruiter: 'Recruteur',

    myProfile: 'Mon profil',
  },
  logoutConfirmation: {
    message: 'Voulez-vous vraiment vous déconnecter d’AppyHere?',
    logout: 'Déconnecter',
    cancel: 'Annuler',
  },
  profile: {
    joinDate: 'A rejoint APPYHERE : {{date}}', // ← hair space U+200A
    isAStudent: 'Étudiant',
    isStudentInfo: 'Ce candidat est un étudiant.',
    adult: 'Adulte',
    adultInfo: 'Ce candidat est agé de 18 ans ou plus.',
    appyPros: {
      title: 'Aperçu du candidat',
      flexibleTransportation: 'A accès à un transport flexible',
      positivePoint: 'Point positif',
    },
    appyNeg: {
      highSalaryDemand: 'Attente salariale élevée',
      negativePoint: 'Point négatif',
    },
    matchingRequisition: {
      title: 'Réquisitions idéales',
      availabilityFitBand: 'Compabilité de la disponibilité:',
      goodFit: 'Bon',
      mediumFit: 'Moyen',
      poorFit: 'Faible',
      badFit: 'Faible',
      noFit: 'Aucun match calculé',
      not_fitFit: 'Aucun match calculé',
      offerMade: 'Faire une offre',
    },
    experience: {
      title: 'Expérience',
      current: 'Actuel',
      none: 'Aucune expérience',
      fetching: "Extraction de l'expérience...",
    },
    resume: 'CV',
    noResumeFound: `Ce candidat n'a pas encore ajouté son CV.`,
    lastUpdatedResume: 'Ajouté le:',
    noResumePreviewAvailable: 'Aucun aperçu disponible',
    education: {
      title: 'Formations',
      none: 'Aucune Formation',
      fetching: 'Extraction des formations...',
      [EducationStatus.completed]: 'Complété',
      [EducationStatus.ongoing]: 'En cours',
      [EducationStatus.dropout]: 'Pas complété',
    },
    availability: {
      title: 'Disponibilité',
    },
    appliedPositions: 'Postes où le candidat a appliqué',
    openRequisitions: 'Réquisitions ouvertes',
    noRequisition: 'No Réquisition',
    updatedAt: 'Mise à jour à:',
    days: 'Jours',
    weeks: 'Semaines',
    immediately: 'Immédiatement',
    download: 'Télécharger le CV virtuel',
    errorResumeDownload: 'Erreur pendant le téléchargement du CV.',
    screened: 'Présélectionné',
    nonScreened: 'Non présélectionné',
    showMore: 'Afficher les candidatures passées',
    showLess: 'Masquer les candidatures passées',
  },
  requisitions: 'Réquisitions',
  allQuestions: {
    title: 'Toutes les questions',
  },
  questions: {
    title: 'Questions spécifiques',
    answerPositive: 'Oui',
    answerNegative: 'Non',
    totalQuestionAnswered: '{{count}} bonne réponse sur un total de {{total}}.',
    totalQuestionAnswered_plural: '{{count}} bonnes réponses sur un total de {{total}}.',
    positiveCount: '{{count}} bonne réponse sur un total de {{total}}.',
    positiveCount_plural: '{{count}} bonnes réponses sur un total de {{total}}.',
    knockoutCount: 'Réponse correcte à {{count}} des {{total}} questions obligatoires.',
    knockoutCount_plural: 'Vous avez répondu correctement à {{count}} des {{total}} questions obligatoires.',
    emptyQuestions: `Aucune question pour la position {{positionName}}. Vous pouvez aller dans l'application AppyHere Employeur pour en ajouter.`,
    noAnswers: `Ce poste n'a aucune question de ce type.`,
    noDocumentsSubmitted: `Ce poste ne contient aucune question sur les documents.`,
    unansweredEngaged: 'Réponses non disponibles.',
    preferredAnswer: 'Réponse préférée',
    knockout: 'Knockout',
    pass: 'RÉUSSI',
    fail: 'ÉCHEC',
  },
  freeFormQuestions: {
    title: 'Questions libres',
    positiveCount: 'Réponse à {{count}} questions sur {{total}}',
    unanswered: 'Cette question est sans réponse.',
  },
  videoResponseQuestions: {
    title: 'Questions avec réponse vidéo',
    positiveCount: 'Réponse à {{count}} questions sur {{total}}',
    unanswered: 'Cette question est sans réponse.',
    skipped: 'Le candidat a choisi de ne pas soumettre de réponse vidéo.',
    noVideoSubmitted: 'Ce poste ne contient aucune question avec réponse vidéo.',
  },
  documentUploadQuestions: {
    title: 'Questions sur les documents',
    positiveCount: 'Réponse à {{count}} questions sur {{total}}',
    unanswered: 'Cette question est sans réponse.',
    skipped: 'Le candidat a choisi de ne pas soumettre de document.',
    totalDocuments: '{{count}} document au total',
    totalDocuments_plural: '{{count}} documents au total',
    previewFailed: "Impossible de charger l'aperçu du document.",
    previewFailedDesc:
      "L'affichage du document a pris trop de temps à répondre. Vous pouvez réessayer l'aperçu ou télécharger le fichier directement.",
  },

  toReviewQuestions: {
    reject: 'Incorrect',
    accept: 'Correct',
    message: {
      selectedCorrectAnswer: 'Le candidat a sélectionné la bonne réponse.',
      selectedIncorrectAnswer: `Ce n'est pas la bonne réponse pour cette question.`,
      correctAnswer: 'Bonne réponse',
    },
    mcq: {
      correctAnswerDetermination: {
        isEqual: {
          anyOptions:
            "Le candidat peut sélectionner le nombre d'options de son choix. Ses réponses doivent correspondre aux bonnes réponses.",
          exactCount:
            'Le candidat doit sélectionner exactement {{count}} option. Sa réponse doit correspondre à la bonne réponse.',
          exactCount_plural:
            'Le candidat doit sélectionner exactement {{count}} options. Ses réponses doivent correspondre aux bonnes réponses.',
        },
        hasAnswer: {
          anyOptions: "Le candidat peut sélectionner le nombre d'options de son choix.",
          atLeastCount: 'Le candidat doit sélectionner au moins {{count}} option.',
          atLeastCount_plural: 'Le candidat doit sélectionner au moins {{count}} options.',
        },
        doesNotHaveAnswer: {
          anyOptions:
            "Le candidat peut sélectionner le nombre d'options de son choix. Ses réponses ne doivent pas inclure de mauvaise réponse.",
          excludeOptions: 'Le candidat ne doit pas inclure les réponses spécifiées dans ses réponses.',
          excludeOptions_plural: 'Le candidat ne doit pas inclure les réponses spécifiées dans ses réponses.',
        },
        atLeast: {
          anyOptions:
            "Le candidat peut sélectionner le nombre d'options de son choix, mais doit inclure au moins une bonne réponse.",
          includeCount: 'Le candidat doit inclure au moins {{count}} bonne réponse.',
          includeCount_plural: 'Le candidat doit inclure au moins {{count}} bonnes réponses.',
        },
      },
    },
  },
  time: {
    relative: {
      lessThan: 'Moins de 6 mois',
      multipleMonths: '{{value}} mois',
      oneYear: '1 an',
      multipleYears: '{{value}} ans',
      moreThan: 'Plus de 10 ans',
    },
  },
  appointmentTypes: {
    inPerson: 'en personne',
    phone: 'Téléphone',
    video: 'vidéo',
    inPhone: 'Téléphone',
  },
  noMessage: 'Pas de message, lancez la conversation!',
  noMessageUnfollowed: `L'historique de messages pour ce candidat est vide.`,
  months: {
    January: 'Janvier',
    February: 'Février',
    March: 'Mars',
    April: 'Avril',
    May: 'Mai',
    June: 'Juin',
    July: 'Juillet',
    August: 'Août',
    September: 'Septembre',
    October: 'Octobre',
    November: 'Novembre',
    December: 'Décembre',
  },
  monthsSmall: {
    jan: 'Jan',
    feb: 'Fév',
    mar: 'Mar',
    apr: 'Avr',
    may: 'Mai',
    jun: 'Jui',
    jul: 'Jui',
    aug: 'Aoû',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Déc',
  },
  informationTab: {
    toastMessage: 'URL copiée',
    headerText: 'URL de la liste des emplois de WebApply',
  },
  tooltip: {
    followedPosition: 'Postes ouverts suivis',
    watchedPosition: 'Poste surveillé',
    ghostedCandidatesList: `Montrer d'autres listes de candidats`,
    favoriteCandidates: 'Mes favoris',
    archivedCandidates: 'Liste des candidats archivés',
  },
  candidates: {
    favoriteCandidatesList: 'Liste des candidats favoris',
    candidatesList: 'Candidats',
    unresponsiveList: 'Liste qui ne répond pas',
    archivedList: 'Liste des candidats archivés',
    ghostingList: 'Candidats qui ne répond pas',
    archiveList: 'Archivé',
    dismissedList: `Rejeté`,
    agedList: `Candidats âgés plus de {{config}} jours`,
    recentList: `Recent List`,
  },
  button: {
    cancel: 'Annuler',
    okay: 'Ok',
    create: 'Créer',
    add: 'Ajouter',
    later: 'Plus tard',
    save: 'Sauvegarder',
    retry: 'Réessayer Aperçu',
    downloadFile: 'Télécharger le fichier',
  },

  searchAndSort: {
    advanceSearch: 'Recherche avancée',
    candidateEngagement: `Niveau d'engagement du candidat`,
    backgroundCheck: `Statut de la vérification des antécédents`,
    ratings: `Évaluation`,
    experience: `Expérience minimale`,
    salary: `Salaire`,
    expectedQuestions: `Questions du poste`,
    availability: 'Disponibilité',
    clearAll: `Réinitialiser les filtres`,
    clearButton: 'Décocher tout',
    applyButton: 'Appliquer',
    saveButton: 'Sauvegarder',
    filter: 'Filtre',
    hireStatus: "Statut de l'embauche",
    i9VerificationStatus: 'Statut de vérification I-9',
    modernHireStatus: 'Évaluation des comptétences',
    requisitionsList: 'Réquisitions',
    availabilityFit: 'Match des disponibilités',
    priority: 'Candidat référé',
    kiosk: 'Candidats kiosque',
    actionRequiredCandidates: "Besoin d'intervention recruteur",
    activeFilters: 'Filtres actifs',
    resetBtn: 'Réinitialiser',
  },
  favoriteCandidate: {
    favoriteCandidate: `Candidats favoris`,
  },
  cadidateEngagementView: {
    engaged: `Sauvegardé`,
    interviewCompleted: `Entrevue complétée`,
    hired: `Embauché`,
    dismissed: `Rejeté`,
    OfferMade: `Faite`,
    offerRejected: 'Rejetée',
    offerAccepted: 'Acceptée',
    appointmentRequested: `Demandée`,
    appoinmentAccepted: 'Acceptée',
    appoinmentDeclined: 'Refusée',
    appoinmentCancled: 'Annulée',
    noAppointmentRequest: 'Présélectionné',
    interestRevoked: `Pas intéressé`,
    contactRequestDeclined: `Demande contact refusé`,
    interview: 'Interview',
    onDemandInterview: 'Interview à la demande',
    offer: 'Offre',
    onDemandInterviewRequested: 'Demandée',
    onDemandInterviewAccepted: 'Acceptée',
    onDemandInterviewDeclined: 'Refusée',
    onDemandInterviewCanceled: 'Annulée',
  },
  backgroundCheck: {
    done: `Complétée`,
    partiallyDone: `Partiellement complétée`,
    notDone: `Pas complétée`,
    Sent: `Envoyé`,
    IN_PROGRESS: `En cours`,
    DISPUTE: `Contesté`,
  },
  availability: {
    day: 'Jour',
    night: 'Nuit',
    evening: 'Soirée',
  },
  salary: {
    hourly: `Horaire`,
    annual: `Annuel`,
    weekly: `Hebdomadaire`,
    monthly: `Mensuel`,
    unit: `Unité`,
    min: `Min`,
    max: `Max`,
  },
  experience: {
    yr: `année`,
    yrs: `années`,
  },
  expectedQuestions: {
    typeYourQuestion: `Choisir une question`,
    expectedQuestion: `Questions`,
    expectedAnswer: `Réponse attendue`,
    yes: `Oui`,
    no: `Non`,
  },
  unresponsivePeriod: {
    day: `jour`,
    days: `jours`,
    agedPeriod: `Délai avant que le candidat soit considéré comme candidat inactif`,
    agedPeriodInfo: `Un candidat est considéré comme inactif s'il ne répond pas à une demande en attente dans le délai fixé par ce paramètre. Une fois ce délai écoulé, le candidat sera déplacé vers la Liste des candidats inactifs.`,
    agedToDismissedPeriod: `Délai avant que le candidat inactif soit rejeté.`,
    agedToDismissedPeriodInfo: `Ce paramètre définit le délai avant qu'un candidat inactif soit automatiquement rejeté.`,
    configUpdateFailed: `La modification des paramètres a échoué.`,
    configUpdateScuccess: `Les paramètres sont sauvegardés.`,
  },
  interviewFeedBack: 'Évaluation du candidat',
  earliestAvailabilityDate: 'Date de disponibilité la plus proche',
  noticePeriod: "Avis pour l'employeur actuel",
  expectedWork: 'Heures de travail disponibles',
  immediately: 'Immédiatement',
  videoInterviewReminder: {
    candidateInfo: "Renseignements sur l'entrevue",
    name: 'Nom du candidat',
    position: 'Poste',
    location: 'Site',
    email: 'Courriel',
    close: 'Fermer',
    joinInterview: "Joindre l'entrevue",
  },
  candidateDetailsDrawer: {
    details: 'Détails',
    positionDetails: 'Renseignements sur le poste',
    candidateDetail: 'Renseignements sur le candidat',
    candidateName: 'Nom du candidat',
    email: 'Courriel',
    phone: 'Téléphone',
  },
  hrsWeek: 'hrs/semaine',
  days: {
    mon: 'lun',
    tue: 'mar',
    wed: 'mer',
    thu: 'jeu',
    fri: 'ven',
    sat: 'sam',
    sun: 'dim',
  },
  candidatesHours: 'Heures du candidat',
  analytics: {
    notAllowed: "Ce compte n'a pas de rapports analytiques de configurés",
    listOfAccessiblePages: 'Liste des pages',
  },
  pagination: {
    showingResult: '{{currentItemsLength}} sur {{totalItemsLength}} résultat',
    itemsPerPage: 'Tâches par page:',
  },
  expand: 'Élargir',
  remove: 'Retirer',
  keepRegardlessLabel: "N'a pas fourni les réponses attendues.",
  keepRegardlessBtn: 'Garder quand même',
  onKeepRegardlessSuccesLabel: 'Le candidat a été sauvé du licenciement',
  hoursToDismissal: {
    zero: 'Va disparaître de cette liste dans quelques minutes',
    one: 'Va disparaître de cette liste dans une heure',
    other: 'Va disparaître de cette liste dans {{count}} heures',
  },
  interviewCandidate: {
    addNote: 'Ajouter une note',
    notes: 'Notes',
    saveNote: 'Sauvegarder la note',
  },
  noPermission: `Vous n'avez pas permission de faire cette action.`,
  somethingWentWrong: 'Something went wrong.',
  noDataAvailable: 'Aucune donnée disponible',
  stringArrayInput: {
    placeholder: 'Ajouter un nouvel ID',
    add: 'Ajouter',
  },
  confirmPopover: {
    confirm: 'Oui',
    cancel: 'Non',
  },
};
